<div
  id="shareConversationModal"
  tabindex="-1"
  role="dialog"
  class="modal fade modal-colored-header"
>
  <div class="modal-dialog modal-lg">
    <div style="background-color: #009">
      <div class="panel-heading headering">
        <h1>Share Conversation</h1>
        <button
          #closeShareModal
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="close()"
        >
          &times;
        </button>
      </div>
    </div>

    <div class="panel-body" style="background-color: white; color: black">
      <div class="col-md-12">
        <div *ngIf="isLoading" class="text-center my-4">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Sharing conversation...
        </div>

        <div *ngIf="!isLoading">
          <div class="share-info mb-4">
            <h4 class="conversation-title-share">
              <span class="s7-share" style="margin-right: 8px"></span>
              {{ shareData?.conversationTitle }}
            </h4>
            <p class="share-description">
              Enter email addresses to share this conversation. Recipients will receive a PDF copy.
              You can optionally change the subject and the content of the email before sending.
            </p>
          </div>

          <div class="email-input-section mb-4">
            <div class="form-group">
              <label for="emailInput" class="form-label">Recipients</label>
              <div class="input-group">
                <input
                  id="emailInput"
                  type="email"
                  class="form-control"
                  placeholder="Enter email address..."
                  [(ngModel)]="emailInput"
                  (keypress)="onEmailKeyPress($event)"
                  autocomplete="off"
                />
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-primary add-email-btn"
                    (click)="addEmail()"
                    [disabled]="!emailInput.trim()"
                  >
                    <span class="s7-plus"></span>
                    Add
                  </button>
                </div>
              </div>
              <div *ngIf="emailInputError" class="error-message">
                <span class="s7-attention"></span>
                {{ emailInputError }}
              </div>
            </div>
          </div>

          <div class="email-list-section" *ngIf="emailList.length > 0">
            <h5 class="email-list-title">
              Recipients ({{ emailList.length }})
            </h5>
            <div class="email-list">
              <div
                *ngFor="let email of emailList; let i = index"
                class="email-item"
              >
                <div class="email-info">
                  <span class="s7-mail"></span>
                  <span class="email-address">{{ email }}</span>
                </div>
                <button
                  type="button"
                  class="remove-email-btn"
                  (click)="removeEmail(i)"
                  title="Remove email"
                >
                  <span class="s7-close"></span>
                </button>
              </div>
            </div>
          </div>

          <div class="no-emails-message" *ngIf="emailList.length === 0">
            <div class="text-center text-muted py-4" style="padding: 4px">
              <span
                class="s7-mail"
                style="font-size: 2rem; opacity: 0.3"
              ></span>
              <p style="margin-top: 1rem">No recipients added yet</p>
            </div>
          </div>
          
          <div class="form-group mt-4">
            <label for="mailSubject" class="form-label">Subject</label>
            <input id="mailSubject" class="form-control mb-3 br-4" type="text" [(ngModel)]="subject" maxlength="200" placeholder="Enter subject..." />
            <label for="mailContent" class="form-label">Content</label>
            <div class="btn-toolbar mb-2" role="toolbar" aria-label="Formatting toolbar">
              <button type="button" class="btn btn-sm mr-1"
                [ngClass]="{'btn-format-active': formatState.bold, 'btn-light': !formatState.bold}"
                (click)="applyFormat('bold')" title="Bold">
                <b [ngStyle]="formatState.bold ? {'color':'#fff'} : {}">B</b>
              </button>
              <button type="button" class="btn btn-sm mr-1"
                [ngClass]="{'btn-format-active': formatState.italic, 'btn-light': !formatState.italic}"
                (click)="applyFormat('italic')" title="Italic">
                <i [ngStyle]="formatState.italic ? {'color':'#fff'} : {}">I</i>
              </button>
              <button type="button" class="btn btn-sm"
                [ngClass]="{'btn-format-active': formatState.underline, 'btn-light': !formatState.underline}"
                (click)="applyFormat('underline')" title="Underline">
                <u [ngStyle]="formatState.underline ? {'color':'#fff'} : {}">U</u>
              </button>
            </div>
            <div id="mailContent" class="form-control br-4" contenteditable="true" (input)="onMailContentInput($event)" (keydown)="onMailContentKeydown($event)" style="min-height: 120px; white-space: pre-wrap; overflow: auto;"></div>
          </div>

          <div class="modal-actions">
            <button
              type="button"
              class="btn btn-primary"
              (click)="shareConversation()"
              [disabled]="emailList.length === 0"
            >
              Share
            </button>
            <button
              type="button"
              class="btn btn-default md-close"
              data-dismiss="modal"
              (click)="close()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
